module.exports = __webpack_public_path__ + "img/upper-egypt-sm.f17a7ab7.jpeg";